module.exports = __webpack_public_path__ + "media/images/subscriptions-icon-0747996a701a0105ddbd728eeb3d9a7b.png";